import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { AddButton } from './AddButton';

interface ApiAddButtonProps extends ComponentProps<typeof AddButton> {
  hasWritePermission: boolean;
}

export const ApiAddButton = ({
  hasWritePermission,
  ...addButtonProps
}: ApiAddButtonProps) => {
  const { t } = useTranslation();

  return (
    <AddButton
      disabled={!hasWritePermission}
      {...(!hasWritePermission && { tooltip: t('Requires write permissions') })}
      {...addButtonProps}
    />
  );
};
